define('views/parts/tree/tree-view',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'src/routes',
    // templates
    'text!templates/parts/tree/tree-item.html',
], function(
    // Libs
    $, _, Backbone, Mustache, U, Routes,
    // templates
    TTreeItem
) {

    // prevent circular dependencies in requirejs
    var VTreeView;
    var VTreeItem = Backbone.View.extend({
        tagName: 'li',
        template: TTreeItem,

        events: {
            "click > .item-label .tree-item-toggle": "onToggle",
            "click > .item-label .text": "onClick",
        },

        regions: {
            tree: "> .tree-view"
        },

        initialize: function(opt) {
            this.options = opt || {};
            this.options.activeAttribute = opt.activeAttribute || "active";

            this.view = {};

            this.listenTo(this.model, 'change:_menuActive', this.onMenuActiveChange);
        },

        render: function() {

            this.$el.html(Mustache.to_html(this.template, {
                label: this.model.get(this.options.label),
                subgroup: this.hasTree()
            }));

            this.generateZones();

            if (this.options.toggleActive) {
                this.toggleActive(this.isActive());
            }

            this.$el.toggleClass('subgroup', this.hasTree());

            if (this.view.tree) {
                this.assign(this.view.tree, this.zone.$tree);
            }

            if (this.options.firstOpen) {
                this.onToggle();
                this.$el.addClass('open');
            }

            return this;
        },

        hasTree: function() {
            return this.model.get(this.options.subgroup) && this.model.get(this.options.subgroup).length > 0;
        },
        isActive: function() {
            return Boolean(this.model.get(this.options.activeAttribute));
        },

        toggleActive: function(val) {
            this.$el.toggleClass('active', val);
        },

        ////////////
        // events //
        ////////////
        onMenuActiveChange: function(model) {
            this.toggleActive(model.get('_menuActive'));
        },

        onToggle: function(e) {

            // lazy create
            if (!this.view.tree) {

                this.view.tree = new VTreeView(_.extend({},
                    _.pick(this.options, [
                        'label',
                        'subgroup',
                        'toggleActive',
                        'activeAttribute',
                        'context',
                        'root'
                    ]), {
                        depth: this.options.depth - 1,
                        collection: this.model.get(this.options.subgroup),
                    }
                ));

                this.assign(this.view.tree, this.zone.$tree);
            }

            this.$el.toggleClass('open');
        },
        onClick: function(e) {
            this.options.root.trigger('click', this.model);

            var callback = this.model.get('callback');
            if (callback) {
                if (this.options.context) {
                    callback.call(this.options.context, this.model);
                } else {
                    callback(this.model);
                }
            }

            if (this.options.toggleActive) {
                this.onDeactivate();
                this.toggleActive(true);
            }

            // this.model.set(this.options.activeAttribute, true);
        },

        onDeactivate: function() {
            this.toggleActive(false);
            this.options.root.onDeactivate();
        },

        onRemove: function() {
            if (this.view.tree) {
                this.view.tree.remove();
            }
        }

    });

    /**
     * Creates a tree view with inlined ul.
     */
    VTreeView = Backbone.View.extend({
        tagName: 'ul',
        className: 'tree-view',

        initialize: function(opt) {
            this.options = opt || {};
            this.options.label = opt.label || "label";
            this.options.subgroup = opt.subgroup || "subgroup";

            // set the root
            if (!this.options.root) {
                this.options.root = this;
            }
            this.root = this.options.root;
        },

        render: function() {
            this.removeChildViews();
            this.$el.empty();

            if (this.options.depth > 0) {
                this.addAll();
            }

            return this;
        },

        addAll: function() {
            this.collection.each(this.addOne, this);
        },

        addOne: function(model) {
            var view = new VTreeItem(_.extend({ model: model }, this.options));
            this.childViews.push(view);
            this.$el.append(view.render().el);
        },

        ////////////
        // events //
        ////////////
        onDeactivate: function() {
            this.$('li').removeClass('active');
        }

    });

    return VTreeView;

});

